
<template> 
    
    <div class="card card-menu mb-5 mb-xxl-8"  v-if="model">
        <div class="card-body pt-3 pb-0">
            <div class="d-flex flex-wrap flex-sm-nowrap">
                <div class="flex-grow-1">
                    <div class="d-flex justify-content-between align-items-start flex-wrap">
                        <div class="d-flex flex-column">
                            <div class="d-flex align-items-center mb-1">
                                <div class="text-white fs-2 fw-bolder me-1">{{  model.usuario.nome }}</div>
                                <div>
                                    <span class="svg-icon svg-icon-1 svg-icon-primary">
                                        <inline-svg src="media/icons/duotone/Design/Verified.svg" />
                                    </span>
                                </div>
                            </div>
                            <div class="d-flex flex-wrap fw-bold fs-6 mb-1 pe-2"> 
                                <div class="d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-1">
                                    <span class="svg-icon svg-icon-4 me-1">
                                        <inline-svg src="media/icons/duotone/General/User.svg" />
                                    </span>
                                    Turma {{ model.turma.descricao  }}
                                </div>  
                            </div>
                            <div class="d-flex flex-wrap fw-bold fs-6 mb-1 pe-2" v-if="model.processoLiminar"> 
                                <div class="d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-1">
                                    <span class="svg-icon svg-icon-4 me-1">
                                        <inline-svg src="media/icons/duotone/General/User.svg" />
                                    </span>
                                    {{  `Liminar: ${model.processoLiminar}`  }}
                                </div>  
                            </div>
                            <div class="d-flex flex-wrap fw-bold fs-6 mb-2 pe-2">
                                <div class="d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2">
                                    <span class="svg-icon svg-icon-4 me-1">
                                        <inline-svg src="media/icons/duotone/General/User.svg" />
                                    </span>
                                    {{  model.status.nome }}
                                </div>  
                                <div class="d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2">
                                    <span class="svg-icon svg-icon-4 me-1">
                                        <inline-svg src="media/icons/duotone/Map/Marker1.svg" />
                                    </span>
                                    {{model.pelotao}}º Pelotão
                                </div>
                                <div class="d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2">
                                    <span class="svg-icon svg-icon-4 me-1">
                                        <inline-svg src="media/icons/duotone/Map/Marker1.svg" />
                                    </span>
                                    Matricula {{model.id}}
                                </div>
                                <div class="d-flex align-items-center text-gray-400 text-hover-primary mb-2">
                                    <span class="svg-icon svg-icon-4 me-1">
                                        <inline-svg src="media/icons/duotone/Communication/Mail-at.svg" />  
                                    </span>
                                    Número {{model.numeroCurso}}{{ model.isRemanescente ? '-R' : '' }}
                                </div>
                                 
                            </div>
                        </div>
                        <div class="d-flex my-2">   
                            <Certificado v-if="model.is_aprovado" :matricula="$route.params.id"  :service="service" :token="token" />  
                            <Editar v-if="hasPermissaoEditar" :matricula="model"  :service="service"  @dados-matricula-alterado="statusAlterado" :perfis="perfis" />
                            <Pdf  :cpf="model.usuario.id" :turmaId="model.turma.id"  /> 
                            <button class="btn btn-sm btn-secondary border border-pmes-primary me-3" @click="gerarBoletimExcell">
                                <span class="menu-icon">
                                    <i class="fas fa-file-excel text-pmes-primary fa-2x bi fs-2x"></i> 
                                </span>
                                Boletim
                            </button> 
                            <button class="btn btn-sm btn-secondary border border-pmes-primary me-3" @click="gerarHistoricoExcell">
                                <span class="menu-icon">
                                    <i class="fas fa-file-excel text-pmes-primary fa-2x bi fs-2x"></i> 
                                </span>
                                Historico
                            </button> 
                        </div>
                    </div>  
                </div>
            </div>
            <div class="d-flex overflow-auto h-55px">
                <ul class="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-6 fw-bolder flex-nowrap">
                    <li class="nav-item"> 
                        <router-link :to="{ name: 'sigap_matricula_show_cadastro' , params: {  id:model.id  } }" class="nav-link text-active-secondary me-6"
                            active-class="active">
                            Cadastro
                        </router-link>
                    </li>
                    <li class="nav-item"> 
                        <router-link :to="{ name: 'sigap_matricula_show_notas' , params: {  id:model.id  } }" class="nav-link text-active-secondary me-6"
                            active-class="active">
                            Avaliações
                        </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link text-active-secondary me-6 " :to="{ name: 'sigap_matricula_show_faltas' , params: {  id:model.id  } }"
                            active-class="active">
                            Faltas
                        </router-link>
                    </li>  
                    <li class="nav-item" v-if="model.status.id != 6">
                        <router-link class="nav-link text-active-secondary me-6 " :to="{ name: 'sigap_matricula_show_faltas_lote' , params: {  id:model.id  } }"
                            active-class="active">
                            Faltas Lote
                        </router-link>
                    </li>  
                    <li class="nav-item">
                        <router-link class="nav-link text-active-secondary me-6 " :to="{ name: 'sigap_matricula_show_boletim' , params: {  id:model.id  } }"
                            active-class="active">
                            Boletim Pdf
                        </router-link>
                    </li>  
                    <li class="nav-item">
                        <router-link class="nav-link text-active-secondary me-6 " :to="{ name: 'sigap_matricula_show_historico' , params: {  id:model.id  } }"
                            active-class="active">
                            Historico Pdf
                        </router-link>
                    </li>  
                    <li class="nav-item">
                        <router-link class="nav-link text-active-secondary me-6 " :to="{ name: 'sigap_matricula_show_historico_notas' , params: {  id:model.id  } }"
                            active-class="active">
                            Historico
                        </router-link>
                    </li>  
                    <li class="nav-item" >
                        <router-link class="nav-link text-active-secondary me-6 " :to="{ name: 'sigap_matricula_show_status' , params: {  id:model.id  } }"
                            active-class="active">
                            Status
                        </router-link>
                    </li>  
                    <li class="nav-item" >
                        <router-link class="nav-link text-active-secondary me-6 " :to="{ name: 'sigap_matricula_show_vf' , params: {  id:model.id  } }"
                            active-class="active">
                            VF
                        </router-link>
                    </li>  
                    <li class="nav-item" >
                        <router-link class="nav-link text-active-secondary me-6 " :to="{ name: 'sigap_matricula_show_reprovacao' , params: {  id:model.id  } }"
                            active-class="active">
                            Reprovacao
                        </router-link>
                    </li>  
                    <li class="nav-item" >
                        <router-link class="nav-link text-active-secondary me-6 " :to="{ name: 'sigap_matricula_show_informacoes' , params: {  id:model.id  } }"
                            active-class="active">
                            Informações
                        </router-link>
                    </li>  
                    <li class="nav-item" >
                        <router-link class="nav-link text-active-secondary me-6 " :to="{ name: 'sigap_matricula_show_opcao' , params: {  id:model.id  } }"
                            active-class="active">
                            Lotações
                        </router-link>
                    </li>  
                    <li class="nav-item" v-if="!isProdrucao || hasAdmin">
                        <router-link class="nav-link text-active-secondary me-6 " :to="{ name: 'sigap_matricula_show_dispensa_medica' , params: {  id:model.id  } }"
                            active-class="active">
                            Dispensa Medica
                        </router-link>
                    </li>  
                    <!-- <li class="nav-item" v-if="hasAdmin">
                        <router-link class="nav-link text-active-secondary me-6 " :to="{ name: 'sigap_matricula_show_logs' , params: {  id:model.id  } }"
                            active-class="active">
                            Logs
                        </router-link>
                    </li> -->
                    <li class="nav-item" v-if="hasAdmin">
                        <router-link class="nav-link text-active-secondary me-6 " :to="{ name: 'sigap_matricula_show_logsql' , params: {  id:model.id  } }"
                            active-class="active">
                            Log Sql
                        </router-link>
                    </li>
                     
                </ul>
            </div>
        </div>
    </div>
 
    <router-view :matricula="model" v-if="model" @matricula-alterado="buscaMatricula"></router-view>
 
</template>

<script lang="ts">   
    
    import MatriculaService from   "@/service/v1/sigap/MatriculaService"  
    import { Options, Vue  } from "vue-class-component";    
    import   SiteUtils   from '@/assets/ts/aplicacao/site';  
    import Editar from   "./_Editar.vue"    
    import Certificado from   "./_Certificado.vue"   
    import { PerfilConfig } from "@/core/config/PerfisConfig"; 
    import { namespace } from 'vuex-class'; 
    const authStore = namespace('auth'); 
    import ApiService from "@/service/ApiService"; 
    import Pdf from "./faltas/_Pdf.vue";

    @Options({
        name: "MatriculaShow",
        components: {   Certificado,  Editar, Pdf  },   
    }) 
    export default class MatriculaShow extends Vue {
        
        @authStore.Getter
		public perfis!: any  

        @authStore.Getter
		public token!: any 
  
        public service = new MatriculaService();
        public model: any = null ;
        public processando = false ;

        public isProdrucao =   ApiService.isProducao();
         
        get hasPermissao( ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.ChefeSTE ,  PerfilConfig.AuxSTE , PerfilConfig.LeituraDE ] ,  this.perfis); 
        }
 
        get hasPermissaoEditar( ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.ChefeSTE ,  PerfilConfig.AuxSTE ] ,  this.perfis); 
        }

        get hasAdmin( ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin  ] ,  this.perfis); 
        }

        public formatCPF( cpf ): string {
            return SiteUtils.formatCPF( cpf );
        }

        created(){
            this.buscaMatricula(); 
        }

        public statusAlterado(dados){ 
            this.buscaMatricula() ;
        }

        public buscaMatricula(){   
            this.processando = true ; 
            this.service.getModel( this.$route.params.id  ) 
            .then(response => {   
                this.model =  JSON.parse(JSON.stringify( response ));  
                this.processando = false ;    
            })
            .catch(error => { 
                this.processando = false ; 
            }); 
        } 
 
        public gerarBoletimExcell() {  
            window.open( this.service.getApiUrl() + '/' + this.$route.params.id + '/Boletim/Excel' + '?token=' +  this.token );
		}
         
        public gerarHistoricoExcell() {  
            window.open( this.service.getApiUrl() + '/' + this.$route.params.id + '/Historico/Excel' + '?token=' +  this.token );
		}
 
    } 
</script>

<style scoped> 
    .btn-sm{
        margin-left: 10px; 
    } 
    .registro-alteracao{
        text-align: right;
    }

    .start-90{
        left: 97% !important;
    }
    
    .col-12{
        margin-bottom: 40px;
    }

    .btn-flex-full{
        max-width: 100%;
        min-width: 100%;
    }
    
    .nav-line-tabs .nav-item .nav-link { 
        margin: 0 0.8rem !important;
    }

    
    .card-menu{
        background-color: #304988 !important;
    }

    .nav-line-tabs .nav-item .nav-link.active, .nav-line-tabs .nav-item.show .nav-link, .nav-line-tabs .nav-item .nav-link:hover:not(.disabled) { 
        border-bottom: 3px solid #E3A11E; 
    }


</style>
